export default "__VITE_ASSET__CGZf7lhO__"